export default {
  'MapZoom.ZoomIn': ({ }, outlet) => {
    outlet({ action: 'ZoomIn' })
  },
  'MapZoom.ZoomOut': ({ }, outlet) => {
    outlet({ action: 'ZoomOut' })
  },
  'MapZoom.Reset': ({ }, outlet) => {
    outlet({ action: 'Reset' })
  }
}